// extracted by mini-css-extract-plugin
export default {"popupPage":"GenericOverlayPopup_popupPage__wJtbY","popupWindow":"GenericOverlayPopup_popupWindow__0mST9"};